let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bf9LE")).then(() => parcelRequire('b1qIP'));